import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Step, Stepper, StepLabel } from '@mui/material';
import { CargoAdmissionTab, AgreementSummaryTab } from '../index';
import { SPP } from '../../../../storePickupPackage.classes';

export const CargoAdmissionLayout = () => {
    const [currentStep, setCurrentStep] = useState(0);

    const { t } = useTranslation();

    const steps = [t('storePickupPackageAdmission.barcodeStep'), t('storePickupPackageAdmission.summaryStep')];

    return (
        <Box className={SPP.admissionLayout} sx={{ paddingBottom: '36px' }}>
            <Stepper
                className={SPP.admissionStepper}
                sx={{ margin: '12px 0 48px 0' }}
                activeStep={currentStep}
                alternativeLabel
            >
                {steps.map((label, index) => (
                    <Step
                        className={SPP.admissionStep}
                        data-step-index={index}
                        sx={{
                            '& .MuiSvgIcon-root': {
                                width: '30px',
                                height: '30px',
                            },
                            '& .Mui-completed': {
                                fill: '#5cb85c',
                            },
                            '& .MuiStepLabel-label.Mui-completed': {
                                color: '#5cb85c',
                            },
                            '& .Mui-active.MuiStepLabel-label': {
                                color: '#03a9f4',
                            },
                        }}
                        key={label}
                    >
                        <StepLabel
                            className={SPP.admissionStepLabel}
                            sx={{
                                '& .MuiStepLabel-label': {
                                    fontSize: '14px',
                                },
                                '& .MuiStepIcon-text': {
                                    fontSize: '12px',
                                    fill: '#fff',
                                },
                            }}
                        >
                            {label}
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>
            {currentStep === 0 && <CargoAdmissionTab setCurrentStep={setCurrentStep} />}
            {currentStep === 1 && <AgreementSummaryTab setCurrentStep={setCurrentStep} currentStep={currentStep} />}
        </Box>
    );
};
